import React from "react";

// TikTok logo with brand colors (cyan + pink + black layered)
export default function TikTokIcon({ className = "w-4 h-4" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Cyan offset */}
      <path
        d="M22.5 8.6c-1.5-1.0-2.4-2.6-2.6-4.4h-3.3v14.0c-.1 1.7-1.5 3.0-3.2 3.0-1.8 0-3.2-1.5-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2.3 0 .7.1 1.0.2v-3.3c-.3-.0-.7-.1-1.0-.1-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5V11.9c1.3.9 2.9 1.5 4.6 1.5V10.1c-.9 0-1.7-.2-2.5-.5z"
        fill="#25F4EE"
        transform="translate(-1.5 1.2)"
      />
      {/* Pink offset */}
      <path
        d="M22.5 8.6c-1.5-1.0-2.4-2.6-2.6-4.4h-3.3v14.0c-.1 1.7-1.5 3.0-3.2 3.0-1.8 0-3.2-1.5-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2.3 0 .7.1 1.0.2v-3.3c-.3-.0-.7-.1-1.0-.1-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5V11.9c1.3.9 2.9 1.5 4.6 1.5V10.1c-.9 0-1.7-.2-2.5-.5z"
        fill="#FE2C55"
        transform="translate(1.5 -1.2)"
      />
      {/* Black main */}
      <path
        d="M22.5 8.6c-1.5-1.0-2.4-2.6-2.6-4.4h-3.3v14.0c-.1 1.7-1.5 3.0-3.2 3.0-1.8 0-3.2-1.5-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2.3 0 .7.1 1.0.2v-3.3c-.3-.0-.7-.1-1.0-.1-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5V11.9c1.3.9 2.9 1.5 4.6 1.5V10.1c-.9 0-1.7-.2-2.5-.5z"
        fill="#111"
      />
    </svg>
  );
}
